var _circle, _circle2, _path, _g, _path2, _g2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStorymetrixchatbird(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_104_2708",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_104_2708)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#053262"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_104_2708",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 10,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18018 7.59277H17V22.8701H7.18018V7.59277Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_104_2708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.36937 21.2277L10.0232 22.0679C10.0481 22.1025 10.0894 22.118 10.1273 22.118C10.1557 22.118 10.184 22.1084 10.2089 22.0894C10.2656 22.0453 10.2751 21.9595 10.2313 21.9035L9.88489 21.4589L10.6298 21.7664C10.6996 21.795 10.7752 21.764 10.8024 21.6937C10.8308 21.6246 10.8001 21.5483 10.7303 21.5197L10.4702 21.4113L11.2399 21.5161C11.2458 21.5161 11.2529 21.5161 11.2588 21.5161C11.325 21.5161 11.3818 21.4685 11.3913 21.3993C11.4007 21.3266 11.3499 21.2599 11.2778 21.2504L9.60466 21.0251V18.9812C9.60466 18.9085 9.54554 18.8477 9.47342 18.8477C9.40129 18.8477 9.34099 18.9085 9.34099 18.9812V21.1419C9.34099 21.1586 9.34454 21.1741 9.35045 21.1872C9.35399 21.1932 9.35636 21.1967 9.35991 21.2027C9.36345 21.2158 9.36582 21.2218 9.36937 21.2277ZM7.51773 19.2827C7.58986 19.2827 7.65016 19.3423 7.65016 19.415V21.7604L9.57037 22.0202C9.6425 22.0298 9.69334 22.0965 9.68388 22.1692C9.67442 22.236 9.61767 22.286 9.55145 22.286C9.54554 22.286 9.53963 22.286 9.53254 22.286L8.51449 22.1502L8.94489 22.3277C9.01465 22.3563 9.04539 22.4326 9.01701 22.5017C8.98863 22.572 8.91296 22.603 8.84438 22.5744L7.92921 22.1978L8.36669 22.758C8.41044 22.8152 8.40098 22.901 8.34423 22.9451C8.3194 22.9641 8.29102 22.9737 8.26264 22.9737C8.22481 22.9737 8.18461 22.9546 8.15859 22.9236L7.41132 21.9666C7.40422 21.9595 7.40186 21.9499 7.39831 21.944C7.39477 21.938 7.3924 21.9344 7.38885 21.9285C7.38294 21.913 7.37939 21.8999 7.37939 21.8844V19.4222C7.38531 19.3423 7.44206 19.2827 7.51773 19.2827ZM15.0721 8.51746C15.0721 8.51746 15.8524 8.09676 16.342 7.68083C16.4342 7.60218 16.569 7.68798 16.537 7.8012C16.4153 8.2648 16.1823 9.02158 15.8335 9.63057C16.258 9.87369 16.6411 10.1561 16.8989 10.3587C16.9899 10.4314 16.9367 10.5804 16.8173 10.5745C16.1788 10.5423 15.3014 10.6817 15.3014 10.6817L14.7611 9.17055C14.9503 9.21822 15.1442 9.29092 15.3393 9.37673L15.0721 8.51746Z",
    fill: "#FED330"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_104_2708",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 5,
    width: 20,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.2002 5.45605H16.2617V22.2362H-2.2002V5.45605Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_104_2708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41418 6.53077C5.36509 7.8298 4.06918 10.236 3.44724 12.5361C3.00384 14.1712 2.67041 15.8755 1.7777 17.3116C0.957118 18.6297 -0.492498 19.6915 -2.00478 19.6212C-2.13012 19.6152 -2.19042 19.7702 -2.09228 19.8524C1.56369 22.8855 8.28206 22.6984 11.9569 19.9537C14.4222 18.11 15.9877 15.1437 16.0693 12.0475C16.1887 7.51994 12.2561 4.1067 8.09642 6.14821C7.86704 6.25904 7.6412 6.38537 7.41418 6.53077Z",
    fill: "#7357EB"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63818 18.5923C6.76325 19.498 10.6994 18.2347 11.0104 15.1599C11.1582 13.7024 9.90015 12.6954 8.58296 12.4892C7.18774 12.2711 6.38844 12.8217 5.83862 13.6929C4.90453 15.1671 4.42684 17.0453 3.63818 18.5923Z",
    fill: "#FED330"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9066 8.72356C10.9232 8.72356 10.935 8.72356 10.9503 8.7176C11.0615 8.69257 11.1301 8.58412 11.1052 8.47328C11.0142 8.05855 11.2743 7.64619 11.687 7.55443C12.0985 7.46266 12.5076 7.72604 12.5986 8.14078C12.6234 8.25161 12.7299 8.32193 12.8398 8.29571C12.9498 8.27068 13.0195 8.16342 12.9947 8.05259C12.8564 7.41499 12.2309 7.01217 11.5983 7.15161C10.9669 7.29104 10.5673 7.92268 10.7056 8.55909C10.7304 8.65682 10.812 8.72356 10.9066 8.72356Z",
    fill: "#34E7E4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorymetrixchatbird);
export default __webpack_public_path__ + "static/media/storymetrix chat bird.77cfb9ffc80b91404c2c47e09516d5a1.svg";
export { ForwardRef as ReactComponent };